import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { LoadingBoundary } from "./components/LoadingScreen";
import { MutationErrorToaster } from "./components/MutationErrorToaster";
import { initI18n } from "./lib/i18n";
import { createAppQueryClient } from "./lib/query-client";
import { applyTheme, storedTheme } from "./lib/theme";
import { createAppRouter } from "./router";
import "./app.css";

initI18n();
applyTheme(storedTheme());

const queryClient = createAppQueryClient();

const router = createAppRouter(queryClient);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LoadingBoundary><RouterProvider router={router} /></LoadingBoundary>
      {/* [UX-B1 #295] toast กลางของ mutation ที่หน้าไม่ได้จัดการ error เอง */}
      <MutationErrorToaster />
    </QueryClientProvider>
  </StrictMode>,
);
